import { useStaticQuery, graphql } from "gatsby";
import { useCallback, useEffect, useState } from "react";
import { has, isString } from "lodash";

import { fetchInline } from "~/utilities/fetchHelper";

import {
    getLocalStorageItem,
    setLocalStorageItem,
} from "~/utilities/localStorageHelpers";

const USER_EMAIL_KEY = "userEmail";

const fetchPardotUser = async (pathname, userEmail) => {
    const prefillUrl = `${process.env.GATSBY_ADMIN_SITE_URL}${pathname}`;

    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: userEmail }),
    };

    return await fetchInline(prefillUrl, options);
};

const useUserPardotData = () => {
    const [userEmail, setUserEmail] = useState("");
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    const {
        wp: { optionsPage },
    } = useStaticQuery(graphql`
        query StaticPardotUserProviderQuery {
            wp {
                optionsPage {
                    globalOptions {
                        pardotUserPrefillUrl
                    }
                }
            }
        }
    `);

    const url = optionsPage?.globalOptions?.pardotUserPrefillUrl;

    const fetchData = useCallback(
        (newUserEmail) => {
            fetchPardotUser(url, newUserEmail)
                .then((pardotData) => {
                    if (has(pardotData, "prospect_id")) {
                        setData(pardotData);
                    } else {
                        const fallbackMsg =
                            "There was a error fetching the Pardot User data.";
                        const msg = pardotData?.message || fallbackMsg;
                        console.error(msg);
                    }
                })
                .catch((error) => {
                    console.error(error.message);
                })
                .finally(() => {
                    setLoading(false);
                });
        },
        [url],
    );

    useEffect(() => {
        const storedUserEmail = getLocalStorageItem(USER_EMAIL_KEY);

        if (storedUserEmail) {
            setLoading(true);
            setUserEmail(storedUserEmail);
            fetchData(storedUserEmail);
        }
    }, [fetchData]);

    return {
        userEmail,
        userData: data,
        isLoading: loading,
        updateUserEmail: (newUserEmail) => {
            if (isString(newUserEmail)) {
                setLocalStorageItem(USER_EMAIL_KEY, newUserEmail);
                setUserEmail(newUserEmail);
                fetchData(newUserEmail);
            }
        },
    };
};

export default useUserPardotData;
